<template>
  <div class="yacht-itinerary-item">
    <div class="trip border border-black-30 rounded p-6">
      <div class="flex mdsm:flex-col">
        <div class="mdsm:w-full yacht-itinerary-item__slider">
          <div>
            <cabin-image-carousel class="yacht-slider" :images="images" />
          </div>
        </div>
        <div class="flex-1 trip-detail-part px-6">
          <h4 class="fs-32 font-bry font-bold">{{ charter_itinerary.name }}</h4>
          <p class="text-black-light-5 mb-8 fs-20">
            {{ charter_itinerary.itinerary_destination_text }}
          </p>
          <p class="mb-8">
            {{
              itinerary.description_override || charter_itinerary.description
            }}
          </p>
          <p class="mb-4" v-html="season" />

          <div class="price-part pt-6 flex flex-col items-end">
            <div class="text-center pr-2">
              <div class="font-bry font-bold">
                from
                <span class="fs-24">
                  <currency-context>
                    <template v-slot="{ convert }">
                      <span v-text="convert(itinerary.price_per_night)"></span>
                    </template>
                  </currency-context>
                </span>
                /night
              </div>
            </div>

            <div class="flex w-full justify-end">
              <itinerary-details
                @enquire="handleEnquire"
                :itinerary="itinerary"
              />

              <button
                type="button"
                class="btn btn-primary ml-4 enquire-button"
                @click="handleEnquire"
              >
                Plan Your Trip
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { mapState } from "vuex";

import CurrencyContext from "../../components/core/CurrencyContext";
import ItineraryDetails from "./ItineraryDetails";
import CabinImageCarousel from "./../liveaboard/CabinImageCarousel";
import SeasonMixin from "./SeasonMixin";
import formatMoney from "../../helpers/formatMoney";

export default {
  mixins: [SeasonMixin],
  components: {
    ItineraryDetails,
    CabinImageCarousel,
    CurrencyContext,
  },
  props: ["itinerary", "index"],
  computed: {
    ...mapState(["supplier"]),
    supplierInfo() {
      return get(this.supplier, "supplier", {});
    },
    images() {
      const itineraryImage = get(this.charter_itinerary, "image");
      const activitiesImages = get(
        this.charter_itinerary,
        "activities",
        []
      ).map((item) => item.activity_image);

      return [itineraryImage, ...activitiesImages];
    },
    highlights() {
      return this.charter_itinerary.highlights;
    },
    season() {
      let out = this.convert(this.monthNumbers);
      out = isEmpty(out) ? "Year round" : out;
      return "<b>Season:</b> " + out;
    },
    pricePerGuest() {
      return (
        this.supplierInfo.price_per_night / this.supplierInfo.max_occupancy
      );
    },
    monthNumbers() {
      try {
        let seasons = JSON.parse(this.itinerary.season);
        return seasons
          .map((monthName) => Number(moment().month(monthName).format("M")))
          .sort((a, b) => a - b);
      } catch (error) {
        return [];
      }
    },
    charter_itinerary() {
      return this.itinerary.charter_itinerary || {};
    },
  },
  methods: {
    handleEnquire() {
      this.$emit("enquire-click", this.itinerary.id);
    },
  },
};
</script>

<style scoped>
.yacht-slider ::v-deep img.cover-image {
  border-radius: 4px;
}

.highlight ::v-deep div {
  display: inline;
}
.highlight-tag {
  font-weight: 500;
  border-radius: 2px;
  color: white;
  line-height: 1rem;
}

.old-price {
  text-decoration: line-through;
}

.enquire-button {
  width: 180px;
}

.fill-discount {
  fill: var(--discount-primary);
}

.trip-highlight-pill {
  border-radius: 2px;
  font-weight: bold;
}

@media screen and (min-width: 601px) and (max-width: 1200px) {
  .enquire-button {
    width: 175px;
  }
}
</style>
